import { render } from "./Done.vue?vue&type=template&id=08a42c52&scoped=true&ts=true"
import script from "./Done.vue?vue&type=script&lang=ts"
export * from "./Done.vue?vue&type=script&lang=ts"

import "./Done.vue?vue&type=style&index=0&id=08a42c52&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a42c52"]])

export default __exports__